module.exports = __webpack_public_path__ + "img/create-terrain.979bd9a2.png";